 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COMMONCOVER from '@/components/Common/cover'
 import COMMONEBB from '@/components/Common/EBB'
 import COMMONTLU from '@/components/Common/TLU'
 import COMMONPORT from '@/components/Common/port'
 import COMMONLOVE1 from '@/components/Common/love1'
 import COMMON01_TITLE from '@/components/Common/01_Title'
 import BOOK1XHTMLCOVER from '@/components/Book1/xhtml/cover'
 import BOOK1XHTML01_TITLE from '@/components/Book1/xhtml/01_Title'
 import BOOK1XHTML02_DEDICATION from '@/components/Book1/xhtml/02_Dedication'
 import BOOK1XHTML03_EPIGRAPH from '@/components/Book1/xhtml/03_Epigraph'
 import BOOK1XHTML04_PART1 from '@/components/Book1/xhtml/04_Part1'
 import BOOK1XHTML05_PART1_1 from '@/components/Book1/xhtml/05_Part1_1'
 import BOOK1XHTML06_P1CH1 from '@/components/Book1/xhtml/06_P1ch1'
 import BOOK1XHTML07_P1CH2 from '@/components/Book1/xhtml/07_P1ch2'
 import BOOK1XHTML08_P1CH3 from '@/components/Book1/xhtml/08_P1ch3'
 import BOOK1XHTML09_P1CH4 from '@/components/Book1/xhtml/09_P1ch4'
 import BOOK1XHTML10_P1CH5 from '@/components/Book1/xhtml/10_P1ch5'
 import BOOK1XHTML11_PART2 from '@/components/Book1/xhtml/11_Part2'
 import BOOK1XHTML12_P2CH1 from '@/components/Book1/xhtml/12_P2ch1'
 import BOOK1XHTML13_P2CH2 from '@/components/Book1/xhtml/13_P2ch2'
 import BOOK1XHTML14_P2CH3 from '@/components/Book1/xhtml/14_P2ch3'
 import BOOK1XHTML15_P2CH4 from '@/components/Book1/xhtml/15_P2ch4'
 import BOOK1XHTML16_P2CH5 from '@/components/Book1/xhtml/16_P2ch5'
 import BOOK1XHTML17_P2CH6 from '@/components/Book1/xhtml/17_P2ch6'
 import BOOK2XHTMLCOVER from '@/components/Book2/xhtml/cover'
 import BOOK2XHTML01_TITLE from '@/components/Book2/xhtml/01_Title'
 import BOOK2XHTML02_DEDI from '@/components/Book2/xhtml/02_Dedi'
 import BOOK2XHTML03_PROLOGUE from '@/components/Book2/xhtml/03_Prologue'
 import BOOK2XHTML04_PART01 from '@/components/Book2/xhtml/04_Part01'
 import BOOK2XHTML05_PT1_CHAPTER01 from '@/components/Book2/xhtml/05_Pt1_chapter01'
 import BOOK2XHTML06_PT1_CHAPTER02 from '@/components/Book2/xhtml/06_Pt1_chapter02'
 import BOOK2XHTML07_PT1_CHAPTER03 from '@/components/Book2/xhtml/07_Pt1_chapter03'
 import BOOK2XHTML08_PT1_CHAPTER04 from '@/components/Book2/xhtml/08_Pt1_chapter04'
 import BOOK2XHTML09_PT1_CHAPTER05 from '@/components/Book2/xhtml/09_Pt1_chapter05'
 import BOOK2XHTML10_PART02 from '@/components/Book2/xhtml/10_Part02'
 import BOOK2XHTML11_PT2_CHAPTER01 from '@/components/Book2/xhtml/11_Pt2_chapter01'
 import BOOK2XHTML12_PT2_CHAPTER02 from '@/components/Book2/xhtml/12_Pt2_chapter02'
 import BOOK2XHTML13_PT2_CHAPTER03 from '@/components/Book2/xhtml/13_Pt2_chapter03'
 import BOOK2XHTML14_PT2_CHAPTER04 from '@/components/Book2/xhtml/14_Pt2_chapter04'
 import BOOK2XHTML15_PT2_CHAPTER05 from '@/components/Book2/xhtml/15_Pt2_chapter05'
 import BOOK2XHTML16_PT2_CHAPTER06 from '@/components/Book2/xhtml/16_Pt2_chapter06'
 import BOOK2XHTML17_PT2_CHAPTER07 from '@/components/Book2/xhtml/17_Pt2_chapter07'
 import BOOK3XHTMLCOVER from '@/components/Book3/xhtml/cover'
 import BOOK3XHTML01_TITLE from '@/components/Book3/xhtml/01_Title'
 import BOOK3XHTML02_DEDICATION from '@/components/Book3/xhtml/02_Dedication'
 import BOOK3XHTML03_EPIGRAPH from '@/components/Book3/xhtml/03_Epigraph'
 import BOOK3XHTML04_CHAPTER1 from '@/components/Book3/xhtml/04_Chapter1'
 import BOOK3XHTML05_CHAPTER2 from '@/components/Book3/xhtml/05_Chapter2'
 import BOOK3XHTML06_CHAPTER3 from '@/components/Book3/xhtml/06_Chapter3'
 import BOOK3XHTML07_CHAPTER4 from '@/components/Book3/xhtml/07_Chapter4'
 import BOOK3XHTML09_CHAPTER5 from '@/components/Book3/xhtml/09_Chapter5'
 import BOOK3XHTML10_CHAPTER6 from '@/components/Book3/xhtml/10_Chapter6'
 import BOOK3XHTML11_CHAPTER7 from '@/components/Book3/xhtml/11_Chapter7'
 import BOOK3XHTML12_CHAPTER8 from '@/components/Book3/xhtml/12_Chapter8'
 import BOOK3XHTML13_CHAPTER9 from '@/components/Book3/xhtml/13_Chapter9'
 import BOOK3XHTML14_CHAPTER10 from '@/components/Book3/xhtml/14_Chapter10'
 import COMMONLOVE2 from '@/components/Common/love2'
 import COMMONAUTHOR from '@/components/Common/Author'
 import COMMONCOPYRIGHT from '@/components/Common/Copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import COMMONORIMAD from '@/components/Common/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Common/cover",
 			"name" : "Common/cover",
 			"component" : COMMONCOVER
 		},
 		{
 			"path" : "/Common/EBB",
 			"name" : "Common/EBB",
 			"component" : COMMONEBB
 		},
 		{
 			"path" : "/Common/TLU",
 			"name" : "Common/TLU",
 			"component" : COMMONTLU
 		},
 		{
 			"path" : "/Common/port",
 			"name" : "Common/port",
 			"component" : COMMONPORT
 		},
 		{
 			"path" : "/Common/love1",
 			"name" : "Common/love1",
 			"component" : COMMONLOVE1
 		},
 		{
 			"path" : "/Common/01_Title",
 			"name" : "Common/01_Title",
 			"component" : COMMON01_TITLE
 		},
 		{
 			"path" : "/Book1/xhtml/cover",
 			"name" : "Book1/xhtml/cover",
 			"component" : BOOK1XHTMLCOVER
 		},
 		{
 			"path" : "/Book1/xhtml/01_Title",
 			"name" : "Book1/xhtml/01_Title",
 			"component" : BOOK1XHTML01_TITLE
 		},
 		{
 			"path" : "/Book1/xhtml/02_Dedication",
 			"name" : "Book1/xhtml/02_Dedication",
 			"component" : BOOK1XHTML02_DEDICATION
 		},
 		{
 			"path" : "/Book1/xhtml/03_Epigraph",
 			"name" : "Book1/xhtml/03_Epigraph",
 			"component" : BOOK1XHTML03_EPIGRAPH
 		},
 		{
 			"path" : "/Book1/xhtml/04_Part1",
 			"name" : "Book1/xhtml/04_Part1",
 			"component" : BOOK1XHTML04_PART1
 		},
 		{
 			"path" : "/Book1/xhtml/05_Part1_1",
 			"name" : "Book1/xhtml/05_Part1_1",
 			"component" : BOOK1XHTML05_PART1_1
 		},
 		{
 			"path" : "/Book1/xhtml/06_P1ch1",
 			"name" : "Book1/xhtml/06_P1ch1",
 			"component" : BOOK1XHTML06_P1CH1
 		},
 		{
 			"path" : "/Book1/xhtml/07_P1ch2",
 			"name" : "Book1/xhtml/07_P1ch2",
 			"component" : BOOK1XHTML07_P1CH2
 		},
 		{
 			"path" : "/Book1/xhtml/08_P1ch3",
 			"name" : "Book1/xhtml/08_P1ch3",
 			"component" : BOOK1XHTML08_P1CH3
 		},
 		{
 			"path" : "/Book1/xhtml/09_P1ch4",
 			"name" : "Book1/xhtml/09_P1ch4",
 			"component" : BOOK1XHTML09_P1CH4
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js